import type { ProductAttributeSelectorProps } from '../config.types';
import type { Option } from '../product.types';
import type { ExtraStyleProps } from './GenericChoiceGroupAttribute';
import { GenericChoiceGroupAttribute } from './GenericChoiceGroupAttribute';
import React from 'react';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

export const DynamicStrikethrough = (props: { show: boolean }) => {
  return (
    <Box
      width={props.show ? '100%' : '0%'}
      height="0px"
      position="absolute"
      left="0px"
      top="calc(50%)"
      borderTop="1.5px solid #333333"
      transition={animationTransition('opacity', 'width')}
      opacity={props.show ? 1 : 0}
    ></Box>
  );
};

const SelectionOption = (props: { label: string; isPossible: boolean }) => {
  const { label, isPossible } = props;

  return (
    <Flex
      flex={1}
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        width="max-content"
        position="relative"
      >
        <DynamicStrikethrough show={!isPossible} />
        <TextV2 typographyVariant="body1">{label}</TextV2>
      </Box>
    </Flex>
  );
};

export const SimpleTextAttribute = (props: ProductAttributeSelectorProps & ExtraStyleProps) => {
  const getOptionComponent = (option: Option, isPossible: boolean, index: number) => {
    return (
      <SelectionOption
        key={index}
        isPossible={isPossible}
        label={option.title}
      />
    );
  };

  const getChoiceGroupName = (option: Option) => {
    return option.title;
  };

  return (
    <GenericChoiceGroupAttribute
      minHeight={55}
      getOptionComponent={getOptionComponent}
      getChoiceGroupName={getChoiceGroupName}
      {...props}
    />
  );
};
